





































import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { ContextsState, ProductsState } from '@/store';
import DataSource from 'devextreme/data/data_source';
import {
    Table,
    TableOptions,
    removeItemsFromView,
    getTableCaption,
} from '@/core/components/table';
import { Page } from '@/core/components/controls';
import { DxDataGrid } from 'devextreme-vue/data-grid';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract,
    EventsServiceContract,
    Events
} from '@/core/contracts';
import { lookupField, guid, encodeParams } from '@/core/helpers';
import { Product, Products } from '@/dto';
import { IContext } from '@/api/dto';
import ProductsListTable from './ProductsListTable.vue';
import DevExpress from 'devextreme/bundles/dx.all';

@Component({
    components: {
        DxDataGrid,
        ProductsListTable,
        TableOptions,
    },
})
export default class ProductsListPage extends Page {
    public table: Table | null = null;
    public tableKey: string = 'products-control';

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public setTable(table: Table): void {
        this.table = table;
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get dataSource(): DataSource {
        return new DataSource({
            key: 'id' as keyof Product,
            load: this.load,
            insert: (product: Product) => this.insert(product),
            update: (id: string, data: Product) => this.update(id, data),
        });
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public get isRowSelected() {
        return this.table && this.table!.getSelectedRowKeys().length === 1;
    }

    public addProduct() {
        this.table!.addRow();
    }

    public editProduct() {
        const selectedKey = this.table!.getSelectedRowKeys()[0];

        if (selectedKey) {
            const selectedIndex = this.table!.getRowIndexByKey(selectedKey);
            this.table!.editRow(selectedIndex);
        }
    }

    private deleteProduct() {
        const table = this.$refs['table-component'] as ProductsListTable;
        table.deleteProduct();
    }

    private async load() {
        const contextId = ContextsState.currentContextId;
        if (ProductsState.current) {
            const productAlias = ProductsState.current.alias;
            const args =  {productAlias};
            const url = `/contexts/${contextId}/productsList?${encodeParams(args)}`;
            return await this._fetchService!.get<Product[]>(url);
        } else {
            const url = `/contexts/${contextId}/productsList`;
            return await this._fetchService!.get<Product[]>(url);
        }
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private async insert(product: Product) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        product.id = guid();
        const data = {
            Products_Partial: [product],
        };
        return await this._fetchService!.post<Product>(
            url,
            JSON.stringify(data)
        );
    }

    private async update(id: string, product: Product) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        product.id = id;
        const data = {
            Products_Partial: [product],
        };
        return await this._fetchService!.post<Product>(
            url,
            JSON.stringify(data)
        );
    }
}
